export default { sha: 'c55372e4cd0958c8ba22f740bb6abb8a9476bd2e', buildNumber: 'undefined' }
